<template>
  <div class="container-fluid h-100">
    <div class="content-login-d" id="content1-login-d">
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100">
        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12 padding-t">
          <!-- <img alt="Tapas" width="250" src="./../../assets/icon/tapas.png"> -->
          <h1 class="club-l">INICIA SESIÓN</h1>
          <p class="ingresa-l">
            Y redime los productos que el Motoclub tiene para tí.
          </p>
        </div>
        <div class=" col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12  ">
          <div
            class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100">
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <span class="fa fa-user icon icon-login" style="color: white"></span>
                  <input 
                    v-model="form.email" 
                    type="text" 
                    class="form-control color-input" 
                    aria-label="Nit"
                    placeholder="NIT" 
                    aria-describedby="basic-addon1"
                    :class="{ 'is-danger': errors.nit }" 
                  />
                </div>
                <span v-if="errors.nit" class="text-danger float-left small error-danger">
                  {{ errors.nit }}
                </span>
              </div>
      
              <div class="form-group">
                <div class="input-group mb-3">
                  <i class="fa fa-lock icon" aria-hidden="true" style="color: white"></i>
                  <input 
                    v-model="form.pass" 
                    type="password" 
                    ref="password"
                    class="form-control color-input" 
                    aria-label="Password"
                    placeholder="CONTRASEÑA" 
                    aria-describedby="basic-addon1" 
                    :class="{ 'is-danger': errors.pass }"
                    @keyup.enter="login()" 
                  />
                  <div @click="showPass()" class="eye_pass">
                    <span id="pass" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span v-if="errors.pass" class="text-danger float-left small error-danger">
                  {{ errors.pass }}
                </span>
              </div>
            </div>
            <div class="pb-3 col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12 mx-auto">
              <a class="reset-password" data-toggle="modal" data-target="#exampleModal">¿Olvidaste la contraseña?</a>
            </div>
            <div class="col-12 col-md-12 col-lg-3 col-xl-3 col-sm-12">
              <button 
                @keyup.enter="login()" 
                :disabled="disableLoading" 
                type="button" 
                @click="login()"
                class="btn btn-danger btn-md btn-block button-register"
              >
                <span v-if="disableLoading">
                  Entrando...
                </span>
                <span v-else>
                  Entrar
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de recuperar contraseña -->
    <div class="modal fade " id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="color: #6c757d">
              Recuperar contraseña
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="input-group mb-3">
                <span class="fa fa-envelope-o icon iconreset"></span>
                <input 
                  v-model="email" 
                  :class="{ 'is-danger': errorsEmail }" 
                  type="text"
                  class="form-control input-reset" 
                  aria-label="email" 
                  placeholder="Email *"
                  aria-describedby="basic-addon1" 
                />
              </div>
              <span v-if="errorsEmail" class="text-danger float-left small error-danger">
                {{ errorsEmail }}
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
              Cerrar
            </button>
            <button 
              @click="resetPassword()" 
              type="button" 
              class="btn btn-danger btn-sm"
            >
              <span 
                v-if="disableLoadingSend" 
                class="spinner-border spinner-border-sm" 
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Enviar</template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {login} from "../../config/auth";
  import {ROL} from "../../config/utils";  
  import {ORIGIN} from "../../config/utils";
  import $ from "jquery";

  export default {
    name: "loginDistributor",

    data() {
      return {
        disableLoading: false,
        disableLoadingSend: false,
        email: "",
        errorsEmail: false,
        errors: {
          nit: false,
          pass: false
        },
        form: {
          email: "",
          pass: ""
        }
      };
    },
    watch: {
      "form.nit": function (n) {
        if (!n) {
          this.errors.nit = "El Nit es requerido.";
          return false;
        } else if (!this.validEmail(n)) {
          this.errors.nit = "El Nit es inválido.";
          return false;
        } else {
          this.errors.nit = false;
        }
      },
      "form.pass": function (n) {
        if (n) {
          this.errors.pass = false;
        } else {
          this.errors.pass = "La contraseña es requerida.";
        }
      },
      email: function (n) {
        if (!n) {
          this.errorsEmail = "El email es requerido.";
        } else if (!this.validEmail(n)) {
          this.errorsEmail = "El email es inválido.";
        } else {
          this.errorsEmail = false;
        }
      }
    },
    methods: {
      login() {
        var app = this;
        if (this.validateForm()) {
          this.disableLoading = true;
          var data_lubircador = {
            origin: ORIGIN.PUNTODEVENTA,
            document_number: app.form.email,
            pass: app.form.pass
          };
          axios
            .post("api/login", data_lubircador)
            .then(function (res) {
              // console.log(JSON.stringify(res));
              if(res.data.access_token != "" && res.data.access_token != undefined){
                login(res.data.access_token);
                var data = {
                  email: app.form.email,
                  validatePass: res.data.ch_pw,
                  gender: res.data.gender_id
                }
                sessionStorage.setItem('infoUser', JSON.stringify(data))
                let encodeUserRole = btoa("userRole");
                let encodeValueUserRole = btoa(res.data.roleId);
                sessionStorage.setItem(encodeUserRole, encodeValueUserRole);
                if (app.$route.params.option == "digitales") {
                  app.$router.push({name: "catalogueEcommerce"});
                } else {
                  app.redirection(res.data.roleId);
                }
              } else {
                app.$swal({
                  icon: "warning",
                  title: "Oops...",
                  html: res.data.messages,
                  confirmButtonColor: "#dc3545"
                });
              }
              app.disableLoading = false;
            })
            .catch(function (err) {
              console.log(err);
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: "Credenciales incorrectas"
              });
              app.disableLoading = false;
            });
        }
      },
      redirection(rolId) {
        switch (rolId) {
          case ROL.PUNTODEVENTAROLE:
            this.$router.push({name: "pointOfsaleProfile"});
            break;
          case ROL.COMMERCIALROLE:
            this.$router.push({name: "comercialProfile"});
            break;
          case ROL.LUBRICATORROLE:
            this.$router.push({name: "lubricatorProfile"});
            break;
          default:
            this.$router.push({name: "profileUser"});
            break;
        }
      },
      resetPassword() {
        var app = this;
        this.disableLoadingSend = true;
        var data = {
          email: this.email
        };
        if (this.validateReset()) {
          axios
            .post("api/password/create", data)
            .then(function (res) {
              if (res.data.ResponseCode == 0) {
                app.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "success",
                  title: "Muy bien",
                  text: res.data.ResponseMessage
                });
              } else if (res.data.ResponseCode == 1) {
                app.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "error",
                  title: "Oops...",
                  text: res.data.ResponseMessage
                });
              } else {
                app.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "error",
                  title: "Oops...",
                  text: "Error al recuperar contraseña"
                });
              }
              app.disableLoadingSend = false;
            })
            .catch(function (error) {
              console.log(error);
              app.disableLoadingSend = false;
            });
        }
      },
      validateForm() {
        if (!this.form.email) {
          this.errors.nit = "El Nit es requerido.";
          return false;
        }
        if (!this.form.pass) {
          this.errors.pass = "La contraseña es requerida.";
          return false;
        }
        if (
          !this.errors.nit &&
          !this.errors.pass &&
          !this.validEmail(this.errors.nit)
        ) {
          return true;
        }
        this.disableLoading = false;
        return false;
      },
      validateReset() {
        if (!this.email) {
          this.errorsEmail = "El email es requerido.";
        }
        if (!this.errorsEmail && !this.validEmail(this.errorsEmail)) {
          return true;
        }
        this.disableLoading = false;
        return false;
      },
      validEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      showPass(){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass').addClass('fa-eye');
          $('#pass').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass').addClass('fa-eye-slash');
          $('#pass').removeClass('fa-eye');
        }
      },
    }
  };
</script>

<style scoped>
.content-login-d {
  padding-left: 5%;
  padding-top: 10%;
  padding-bottom: 5%;
  height: 100%;
}
.small-register{
  font-family: "GothamBoldItalic", sans-serif !important;
}
.club-l {
  font-size: 55px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.ingresa-l {
  font-size: 23px;
  text-align: left;
  font-family: "GothamBookItalic", sans-serif;
}
.t-c {
  text-align: center;
}
label.text-login{
  margin-bottom: 0rem;
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 15px;
}
#content1-login-d {
  background-size: cover;
  background-image: url("../../assets/img/fondo_login_puntos_de_venta.jpg ");
  background-position: center top;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
a.reset-password {
  cursor: pointer !important;
  color: white;
}
a.reset-password:hover {
  color: #b3b3b3 !important;
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.icon-disable {
  color: #676565 !important;
}
.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}
.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}
.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .content-login-d {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content-login-d {
    height: 100%;
  }
  .padding-t {
    padding-top: 5%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .content-login-d {
    padding-left: 0%;
    padding-top: 25%;
    padding-bottom: 30%;
  }
  .club-l {
    font-size: 35px;
    text-align: center;
  }
  .ingresa-l {
    font-size: 18px;
    text-align: center;
  }
  .margin-btn {
    margin-bottom: 35%;
  }
}
</style>